/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found matching your search.`)
};

const es_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados que coincidan con tu búsqueda.`)
};

const de_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse für deine Suche gefunden.`)
};

const nl_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaten gevonden die overeenkomen met je zoekopdracht.`)
};

const fr_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat trouvé correspondant à votre recherche.`)
};

const it_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato trovato corrispondente alla ricerca.`)
};

const pt_br2_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado encontrado para sua busca.`)
};

const pt_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado encontrado para a sua pesquisa.`)
};

const ja_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索に一致する結果がありません。`)
};

const zh_f1_stats_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到符合搜索的结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stats_no_results = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stats_no_results(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stats_no_results", locale)
	if (locale === "en") return en_f1_stats_no_results(inputs)
	if (locale === "es") return es_f1_stats_no_results(inputs)
	if (locale === "de") return de_f1_stats_no_results(inputs)
	if (locale === "nl") return nl_f1_stats_no_results(inputs)
	if (locale === "fr") return fr_f1_stats_no_results(inputs)
	if (locale === "it") return it_f1_stats_no_results(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stats_no_results(inputs)
	if (locale === "pt") return pt_f1_stats_no_results(inputs)
	if (locale === "ja") return ja_f1_stats_no_results(inputs)
	return zh_f1_stats_no_results(inputs)
};